var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('div',{staticClass:"py-5 text-center"},[_c('h1',{staticClass:"display-3"},[_vm._v(" 正在建设中…… ")]),_c('h2',{staticClass:"mb-4"},[_vm._v("请稍后访问")]),_c('b-button',{attrs:{"href":"/"}},[_vm._v("Go to home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }